import { injectable, inject } from 'inversify';
import { RpcSuccess } from '@dealroadshow/json-rpc-dispatcher';
import Request from '@framework/api/Rpc/Request';
import { type IDispatcherFactory } from '@dataroom/json-rpc-dispatcher';
import DITypes from '@dataroom/json-rpc-dispatcher/DITypes';
import { IScheduleDemoPayload } from '@framework/ui/Organisms/ScheduleDemo/vo/ScheduleDemoPayload';

interface ICurrency {
  id: string,
  abbreviation: string,
  description: string,
  symbol: string,
  isDefault: boolean,
}

interface IPeriod {
  id: string,
  displayName: string,
}

interface ISize {
  id: string,
  display_name: string,
  pages: number,
}

interface IPricing {
  [key: string]: {
    [key: string]: string,
  },
}

export interface IDealVdrPayload {
  periodId: string,
  dataroomSizePlanId: number,
  currencyId: string,
  companyName: string,
  firstName: string,
  lastName: string,
  corporateEmail: string,
  phoneNumber: string,
  notes: string,
  isCallbackRequested: boolean,
  recaptchaToken: string,
}

export interface I17g5Payload {
  dataroomAmount: number,
  currentProvider: string,
  companyName: string,
  firstName: string,
  lastName: string,
  corporateEmail: string,
  phoneNumber: string,
  notes: string,
  isCallbackRequested: boolean,
  recaptchaToken: string,
}

@injectable()
class LandingRepository {
  constructor(
    @inject(DITypes.JsonRpcDispatcher) private readonly rpc: IDispatcherFactory,
  ) {}

  getQuote = async (payload: IDealVdrPayload | I17g5Payload): Promise<IScheduleDemoPayload> => {
    const request = new Request('landing.generate_instant_quote', payload);
    const response = await this.rpc().call<RpcSuccess>(request);

    return response.getResult();
  };

  getSizes = async (): Promise<ISize[]> => {
    const request = new Request('landing.get_sizes');
    const response = await this.rpc().call<RpcSuccess>(request);

    return response.getResult() as any;
  };

  getCurrencies = async (): Promise<ICurrency[]> => {
    const request = new Request('landing.get_currencies');
    const response = await this.rpc().call<RpcSuccess>(request);

    return response.getResult() as any;
  };

  getPricing = async (payload: { currencyId: string }): Promise<IPricing> => {
    const request = new Request('landing.get_pricing', payload);
    const response = await this.rpc().call<RpcSuccess>(request);

    return response.getResult() as any;
  };

  getPeriods = async (): Promise<IPeriod[]> => {
    const request = new Request('landing.get_periods');
    const response = await this.rpc().call<RpcSuccess>(request);

    return response.getResult() as any;
  };
}

export default LandingRepository;
